export default "__VITE_ASSET__Ct5hZ$Z1__"